import { createContext, useContext, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { memberRole } from "@/lib/teamData";

// Permessi (mock, localStorage). Il MASTER (role=admin) vede/gestisce tutto e
// controlla i permessi. Le altre risorse interne vedono tutto TRANNE i moduli
// riservati (amministrazione, contabilità, HR-admin), salvo abilitazione dal master.
// Futuro: Supabase roles + RLS.
const KEY = "aesthetic-os-permissions";
const PermissionsContext = createContext(null);

// Moduli riservati configurabili dal Super Admin. HR è riservato al Super Admin.
export const GATED_MODULES = ["amministrazione", "contabilita"];
export const GATED_LABELS = { amministrazione: "Amministrazione", contabilita: "Contabilità", hr: "Risorse Umane (HR)" };

const DEFAULTS = {
  team: { amministrazione: false, contabilita: false, hr: false },
};

const load = () => { try { const raw = localStorage.getItem(KEY); if (raw) return { ...DEFAULTS, ...JSON.parse(raw) }; } catch {} return DEFAULTS; };

export function PermissionsProvider({ children }) {
  const [perms, setPerms] = useState(load);

  const setPerm = (role, moduleKey, value) => {
    const next = { ...perms, [role]: { ...(perms[role] || {}), [moduleKey]: value } };
    localStorage.setItem(KEY, JSON.stringify(next));
    setPerms(next);
  };

  return (
    <PermissionsContext.Provider value={{ perms, setPerm }}>
      {children}
    </PermissionsContext.Provider>
  );
}

export const usePermissions = () => useContext(PermissionsContext);

// Helpers basati sull'utente + permessi correnti.
export const isMaster = (user) => user?.role === "super_admin" || user?.role === "admin";

export function useModuleAccess() {
  const { user } = useAuth();
  const { perms } = usePermissions();
  const role = (user && user.role !== "client_user" && memberRole(user.id)) || user?.role;
  const master = role === "super_admin" || role === "admin";

  const canAccess = (moduleKey) => {
    if (!user || user.role === "client_user") return false;
    if (master) return true;
    // Amministrazione, Contabilità e HR sono riservati (Team escluso salvo abilitazione).
    if (GATED_MODULES.includes(moduleKey)) return !!perms?.[role]?.[moduleKey];
    return true;                                    // tutti gli altri moduli operativi
  };

  return { canAccess, isMaster: master, role };
}
